// useStreamHandler.js
import { useEffect, useState } from 'react';
import StreamHandler from './StreamHandler';

function useStreamHandler(streamUrl, headers) {
  const [data, setData] = useState('');
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (streamUrl && headers) {
      setData('');
      setIsComplete(false);

      const streamHandler = new StreamHandler(
        newData => {
          setData(newData);
        },
        () => {
          setIsComplete(true);
        }
      );

      streamHandler.startStream(streamUrl, headers);

      return () => {
        streamHandler.closeStream();
      };
    }
  }, [streamUrl, headers]);

  return { data, isComplete };
}

export default useStreamHandler;